@if (loadingService.loading()) {
  <div class="loading-overlay">
    <mat-spinner diameter="40"></mat-spinner>
  </div>
}
